var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.75C8.2125 11.75 8.39062 11.6781 8.53437 11.5344C8.67812 11.3906 8.75 11.2125 8.75 11C8.75 10.7875 8.67812 10.6094 8.53437 10.4656C8.39062 10.3219 8.2125 10.25 8 10.25C7.7875 10.25 7.60937 10.3219 7.46562 10.4656C7.32187 10.6094 7.25 10.7875 7.25 11C7.25 11.2125 7.32187 11.3906 7.46562 11.5344C7.60937 11.6781 7.7875 11.75 8 11.75ZM7.25 8.75H8.75V4.25H7.25V8.75ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9812 2.69375 13.3062C2.01875 12.6312 1.48437 11.8375 1.09062 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09062 5.075C1.48437 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48437 5.075 1.09062C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09062C11.8375 1.48437 12.6312 2.01875 13.3062 2.69375C13.9812 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9812 12.6312 13.3062 13.3062C12.6312 13.9812 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5Z",
    fill: "#E21508"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIssue);
export default __webpack_public_path__ + "static/media/dateIssue.44bf93616d3dee7fac7b2b56d4cc5fea.svg";
export { ForwardRef as ReactComponent };